import {
    IS_LOADING_SEND_MESSAGE, SEND_MESSAGE, CONVERSATION, IS_LOADING_SEND_MESSAGE_ROOM, IS_LOADING_CONVERSATION, SEND_MESSAGE_ROOM, IS_LOADING_CONVERSATION_ROOM, CONVERSATION_ROOM,
    IS_LOADING_CONVERSATIONS_LIST, CONVERSATIONS_LIST, NEW_MESSAGE, DELETE_CONVERSATION, NEW_MESSAGE_ROOM
} from '../actions/types'

const initialState = {

    isLoadingSendMessage: false,
    isLoadingConversation: {},
    isLoadingSendMessageRoom: false,
    isLoadingConversationRoom: false,
    idCurrentChat: null,
    sendMessage: [],
    conversation: [],
    dataReload: null,
    sendMessageRoom: [],
    conversationRoom: [],
    isLoadingConversationsList: true,
    conversationsList: []
}

export default function (state = initialState, action) {
    switch (action.type) {

        case IS_LOADING_SEND_MESSAGE:
            return { ...state, isLoadingSendMessage: true }

        case SEND_MESSAGE:
            return { ...state, isLoadingSendMessage: false, sendMessage: action.payload }

        case IS_LOADING_CONVERSATION:
            var newConversationLoading = Array.from(state.isLoadingConversation)
            newConversationLoading[action.payload] = true
            return { ...state, isLoadingConversation: newConversationLoading }

        case CONVERSATION:
            var newConversation = state.conversation
            var newConversationLoading = Array.from(state.isLoadingConversation)
            newConversation[action.payload.idUser] = action.payload.dataConversation
            newConversationLoading[action.payload.idUser] = false
            return { ...state, conversation: newConversation, isLoadingConversation: newConversationLoading, dataReload: action.payload.dataReload }

        case NEW_MESSAGE:
            var addNewMessage = Array.from(state.conversation)
            var addNewLastMessage = Array.from(state.conversationsList)
            var newConversationLoading = Array.from(state.isLoadingConversation)
            if (action.payload.isIncoming)
                newConversationLoading[action.payload.dataMsgContent.senderID] = false
            else
                newConversationLoading[action.payload.dataMsgContent.addresseeID] = false

                

            for (let index = 0; index < addNewLastMessage.length; index++) {
                if (addNewLastMessage[index].conversation._id === action.payload.dataMsgContent.senderID)
                    addNewLastMessage[index].conversation.lastMessage = action.payload.dataMsgContent
            }
            console.log("action.payload",action.payload);

            if (action.payload.isIncoming) {
                console.log();
                if (addNewMessage[action.payload.dataMsgContent.senderID]) {
                    console.log();
                    addNewMessage[action.payload.dataMsgContent.senderID].push(action.payload.dataMsgContent)
                }

                else {
                    addNewMessage[action.payload.dataMsgContent.senderID] = []
                    console.log();
                    addNewMessage[action.payload.dataMsgContent.senderID].push(action.payload.dataMsgContent)
                }
            }
            else
                addNewMessage[action.payload.dataMsgContent.addresseeID] ?
                    addNewMessage[action.payload.dataMsgContent.addresseeID].push(action.payload.dataMsgContent) :
                    addNewMessage[action.payload.dataMsgContent.addresseeID] = [action.payload.dataMsgContent]

            console.log()
            return { ...state, conversation: addNewMessage, isLoadingConversation: newConversationLoading, conversationsList: addNewLastMessage, isLoadingConversationsList: false }

        case IS_LOADING_SEND_MESSAGE_ROOM:
            return { ...state, isLoadingSendMessageRoom: true }
            
        case SEND_MESSAGE_ROOM:
            return { ...state, isLoadingSendMessageRoom: false, sendMessageRoom: action.payload }
            
        case IS_LOADING_CONVERSATION_ROOM:
            return { ...state, isLoadingConversationRoom: true }
            
        case CONVERSATION_ROOM:
            return { ...state, conversationRoom: action.payload, isLoadingConversationRoom: false }
            
        case NEW_MESSAGE_ROOM:
            var addNewMessage = state.conversationRoom
            addNewMessage.push(action.payload)
            return { ...state, conversationRoom: addNewMessage, isLoadingConversationRoom: false }
            
        case IS_LOADING_CONVERSATIONS_LIST:
            return { ...state, isLoadingConversationsList: true }
            
        case CONVERSATIONS_LIST:
            return { ...state, isLoadingConversationsList: false, conversationsList: action.payload }
            
        case DELETE_CONVERSATION:
            var deleteConversation = state.conversationsList
                deleteConversation.splice(action.payload.index, 1);
            return { ...state, isLoadingConversationsList: false, conversationsList: deleteConversation }
            
        default:
            return state
    }
}